import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Features from "../components/landing/Features";
import Gallery from "../components/landing/Gallery";
import Location from "../components/landing/Location";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";
import WhatsAppFloat from "../components/landing/WhatsAppFloat";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#2D2920] font-body" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Features />
        <Gallery />
        <Location />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
